module.exports = __webpack_public_path__ + "static/media/chat-active.8aa145c6.svg";